import Api from './Core/Api';
import AppHistory from './Core/AppHistory';
import CordovaUtils from './Core/Cordova';
import Culture from './Core/Culture';
import FaLibrary from './Core/FaLibrary';
import Menus from './Core/Menus';
import { PublicRoutes } from './Core/PublicRoutes';
import SecureStorage from './Core/SecureStorage';
import UserManager from './Core/UserManager';
var CoreHelpers = /** @class */ (function () {
    function CoreHelpers() {
        /**Check if App is running natively */
        this.IsNative = false;
    }
    /**
     * Class initializer
     * @param {IAppProps} appProps Caller application properties
     * @returns {Promise<number>} Promise of type number
     */
    CoreHelpers.prototype.Init = function (appProps) {
        var _this = this;
        var that = this;
        return new Promise(function (resolve, reject) {
            that.IsNative = CordovaUtils.IsCordova;
            that.AppName = appProps.AppName;
            that.AppTitle = appProps.AppTitle;
            that.AppDownload = appProps.AppDownload;
            that.PublicTrackAndTrace = appProps.PublicTrackAndTrace;
            that.UserRegisterPage = appProps.UserRegisterPage === undefined ? false : appProps.UserRegisterPage;
            AppHistory.Initialize(_this.AddBaseAppPublicRoutes(appProps.PublicRoutes));
            FaLibrary.Initialize(appProps.IconLibrary);
            SecureStorage.OpenSecureStorage(appProps.Authority.ClientId, that.IsNative)
                .then(function () {
                UserManager.Initialize(appProps.Authority).then(function () {
                    Culture.Init().then(function () {
                        if (!AppHistory.Online) {
                            resolve(1);
                        }
                        else {
                            if (!that.IsNative || (CordovaUtils.IsElectron && UserManager.IsSignedIn)) {
                                that.InitApiDependencies().then(function (res) {
                                    resolve(res);
                                }).catch(function (err) {
                                    reject(err);
                                });
                            }
                            else {
                                resolve(1);
                            }
                        }
                    });
                });
            });
        });
    };
    /**
     * Add public routes for controllers that belong to base app
     * @param {Array<string>} pRoutes Completes list of public routes
     */
    CoreHelpers.prototype.AddBaseAppPublicRoutes = function (pRoutes) {
        pRoutes.push(PublicRoutes.TrackAndTrace);
        pRoutes.push(PublicRoutes.TrackAndTrace + "/:id+");
        return pRoutes;
    };
    /**
     * Continue app initialization
     * @returns {Promise<number>} Promise of number: -1 (401 Denied), 0 (Unknown error), 1 (OK)
     * */
    CoreHelpers.prototype.InitApiDependencies = function () {
        var that = this;
        return new Promise(function (resolve, reject) {
            Api.GetAppConfig(that.AppName).then(function (data) {
                if (data !== null && isNaN(data) && data.Menus !== null) {
                    Menus.Init(data.Menus);
                    that.ShippersList = data.Shippers;
                    resolve(1);
                }
                else if (data === -1) {
                    resolve(1);
                }
                else {
                    resolve(-1);
                }
            }).catch(function (err) {
                console.error("[InitDependencies-3] - " + err);
                reject(0);
            });
        });
    };
    return CoreHelpers;
}());
var Core = new CoreHelpers();
export default Core;
//# sourceMappingURL=Core.js.map